import { Icons } from "@airhelp/react-ui-components";
import type { StickyBottomBarIconProps } from "./StickyBottomBar.d";

export const iconsWithText: StickyBottomBarIconProps[] = [
  { icon: Icons.Airplane, textKey: "all_airlines" },
  { icon: Icons.GlobeAround, textKey: "all_countries" },
  { icon: Icons.Protect, textKey: "no_win_no_fee" },
];
